import { QueryCache, QueryClient } from '@tanstack/react-query';

import { checkIsSsr } from '@shared/utils/check-is-ssr';

import { ErrorFetch } from './errors';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // No browser to redirect on the server, and `window` is undefined there —
      // touching it would throw out of this side-effect callback and could crash
      // the process. Let the loader's catch handle the failure; the client-side
      // route guards perform the actual /signin redirect after hydration.
      if (checkIsSsr()) {
        return;
      }

      if (error instanceof ErrorFetch && error.status === 401) {
        window.location.href = '/signin';
      }
    },
  }),
});
